export default {"src":"/_next/static/media/section-adornment2-m.c32d02ec.svg","height":40,"width":375,"blurWidth":0,"blurHeight":0};